export var ContentTaskStatus;
(function (ContentTaskStatus) {
    ContentTaskStatus[ContentTaskStatus["OPEN"] = 10] = "OPEN";
    ContentTaskStatus[ContentTaskStatus["COMPLETED"] = 20] = "COMPLETED";
})(ContentTaskStatus || (ContentTaskStatus = {}));
//# sourceMappingURL=content-task-status.enum.js.map